// Disable SSR for the entire app - required for static adapter SPA mode
export const ssr = false;
export const prerender = true;
